import { Component, OnInit } from '@angular/core';
import { InvoiceService } from '../../../services/invoice.service';
import { ClientService } from '../../../services/client.service';
import Swal from 'sweetalert2';
import { PetToInvoiceModel } from '../../../models/invoice-model';
import { PaymentDetailsModel } from '../../../models/invoice-model';
import { PetInvoiceListModel } from "../../../models/invoice-compiled.model";
import { Router, ActivatedRoute } from '@angular/router';
declare var $: any;

@Component({
  selector: 'ngx-invoicing',
  templateUrl: './invoicing.component.html' 
})
export class InvoicingComponent implements OnInit { 
  expandedRows: { [key: number]: boolean } = {};
  expandedNotesRows: { [key: number]: boolean } = {};
  expandedAlertsRows: { [key: number]: boolean } = {};
  PetsToDecideForInvoice = [] 
  pet_invoice_listModel: PetInvoiceListModel[] = []

  loading: boolean = false;

  constructor(
    public invoiceService:InvoiceService,
    public clientService:ClientService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.clientService.work_standalone_page = true
    this.clientService.work_pet_ribbon = false
    this.clientService.work_brief = false
 
    this.getCompiledInvList() 
    this.invoiceService.GetTaxRate(this.invoiceService.userData.clinic_no).then((res:number)=>{
      this.invoiceService.tax_rate = res / 100 
    })
    this.invoiceService.GetClinicRabiesCode(this.invoiceService.userData.clinic_no)
    // load active rabies vaccines for modal
    this.invoiceService.GetActiveRabiesVaccine().then(() => {
      this.activeRabiesVaccine = this.invoiceService.activeRabiesVaccine || [];
    });
  }

  //html comp
  checkAll(){
    $('.checkbox-item').prop('checked', true);
  }

  uncheckAll(){
    $('.checkbox-item').prop('checked', false);
  } 

  toggleProceduresTable(index: number) {
    this.expandedRows[index] = !this.expandedRows[index];
  }

  toggleNotesTable(index: number) {
    this.expandedNotesRows[index] = !this.expandedNotesRows[index];
  }

  getCompiledInvList(){ 
    this.loading = true;
    this.invoiceService.GetCompiledInvoiceList(this.clientService.current_client_no,this.invoiceService.userData.clinic_no, 0).then((item)=>{
      this.invoiceService.DisplayToTable(item).then(()=>{
        this.loading = false;
      })
    })
  }
  
  get noPetsToInvoice(){
    return this.invoiceService.compiled_PetINV.every(item => !(item.currentBalance > 0 || (item.procsDetails?.done?.length > 0)));
  }


  //Functionalities
  
  
  async invoiceFunction(){  
    var checkedCheckboxes = $('.checkbox-item:checked');  
    var component = this; // Capture the component's 'this'
    var checked_compiled_PetINV = []
    component.invoiceService.pet_to_invoice_list = []
    component.invoiceService.payment_Details_list = []
    this.PetsToDecideForInvoice = []
    
    await checkedCheckboxes.each(function() {  
      let ipetno = $(this).val() 
      let ipetName = $(this).data('petname');
      let ipetIndex = $(this).data('index'); 
      const targetPet = component.invoiceService.compiled_PetINV.find(pet => pet.pet_no == ipetno); 
 
      let vPetToInvoiceModel = new PetToInvoiceModel(ipetno,ipetName,ipetIndex,targetPet.rabiesDets,targetPet.ToBeInvoiced,targetPet.Amount,targetPet.TaxAmt,targetPet.currentBalance);  
      component.invoiceService.pet_to_invoice_list.push(vPetToInvoiceModel)
      checked_compiled_PetINV.push(targetPet)

      let vpayment_Details_list = new PaymentDetailsModel(ipetno,targetPet.Amount,targetPet.Amount,0,targetPet.TaxAmt,targetPet.currentBalance,0,0,0,0,0,0,targetPet.PetDeposit,0)
      component.invoiceService.payment_Details_list.push(vpayment_Details_list)
    });
 
    for(let i=0;i<checked_compiled_PetINV.length;i++){
      if(checked_compiled_PetINV[i].ToBeInvoiced == false){ 
        console.log("HEY HERE",checked_compiled_PetINV[i])
        this.PetsToDecideForInvoice.push(checked_compiled_PetINV[i])  
      }
    } 
  
    if(this.PetsToDecideForInvoice.length == 0){
      this.invoiceService.pet_to_invoice_list.forEach(item => {
        item.ToBeInvoiced = true;
      });
      
      // $('#modalinvcashreg').modal('toggle') 
      // navigate to sibling route under the Work module to avoid navigating to root which can trigger auth redirect
      const relativeTo = this.route.parent || this.route;
      this.router.navigate(['inv-casgreg'], { relativeTo }).then(() => {
        this.invoiceService.notifyPayRegFunction();
      });
    }
    else{
      $('#Modal_UnfinishedProcList').modal('toggle') 
    }
    
  }

  UnfinishedModal_ContinueBtn(){ 
    var uncheckedCheckboxes = $('.cb_PetsUnfinishedProcs:not(:checked)');
    var component = this;
    uncheckedCheckboxes.each(function() {  
      let petNoToRemove = $(this).val();
      component.invoiceService.pet_to_invoice_list = component.invoiceService.pet_to_invoice_list.filter(pet => pet.pet_no !== petNoToRemove);
    
    })

    this.invoiceService.pet_to_invoice_list.forEach(item => {
      item.ToBeInvoiced = true;
    });
    
    // close modal first, navigate, then notify so the target component is created and can receive the notification
    $('#Modal_UnfinishedProcList').modal('toggle');
    const relativeTo = this.route.parent || this.route;
    this.router.navigate(['inv-casgreg'], { relativeTo }).then(() => {
      this.invoiceService.notifyPayRegFunction();
    });
  }


  //#region Rabies Vaccine
  getActiveRabiesVaccine(){
    this.invoiceService.GetActiveRabiesVaccine().then((res: any) => {
      console.log(res)
    })
  }

  activeRabiesVaccine: any[] = [];
  selectedActiveRabiesVaccineIndex: number | null = null;

  selectRabiesVaccine(index: number) {
    this.selectedActiveRabiesVaccineIndex = index;
  }

  openActiveRabiesVaccine() {
    $('#modalActiveRabiesVaccine').modal('toggle');
  }

  //#endregion Rabies Vaccine

  sampleClick(){
    console.log(this.invoiceService.compiled_PetINV) 
  }

  // Round up numeric value to nearest penny (cent)
  roundUpToPenny(value: number): number {
    const num = Number(value) || 0;
    return Math.ceil(num * 100) / 100;
  }

  roundUpToQuarter(value: number): number {
      const num = Number(value) || 0;
      // Multiplied by 4 because $1.00 / $0.25 = 4
      return Math.ceil(num * 4) / 4;
  }

  // openInvModal(pet_no){
  //   this.invoiceService.notify_InvSoloModalFunction('invpage',pet_no); 
  // }

}
